
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import config from '../../config/config';
import { useBranding } from '../../context/BrandingContext';
import MyButton from '../../shared-components/button/button';
import CustomInput from '../../shared-components/custom-input/CustomInput';
import getFirstSubdomain from '../../shared-functions/DomiansplitFunction';
import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from '../../shared-functions/LocalStorage';
import charger from '../../utils/api/charger';
// import hyperPay from '../../utils/api/hyperPay';

/**
 * Apple Pay Component
 * @returns
 */
function HyperPayApplePayComponent() {
  const { search } = useLocation();
  const domain = getFirstSubdomain();
  const { brandData } = useBranding();
  const navigate = useNavigate();
  const [guestToken, setGuestToken] = useState(getLocalStorageItem('guestToken'));
  const [checkoutId, setCheckoutId] = useState<string>('');
  const [checkoutAppleId, setCheckoutAppleId] = useState<string>('');
  const message = getLocalStorageItem('apiResponse');

  /**
   * submitCheckoutId
   * @returns
   */
  const submitCheckoutId = () => {
    alert(JSON.stringify({ checkoutId }));
    // ✅ Define global config before loading the script
    (window as any).wpwlOptions = {
      style: 'plain',
      paymentTarget: '_top',
      applePay: {
        // displayName: 'Energic App',
        // totalLabel: 'Energic Charge',
        displayName: 'Energic App',
        total: { label: 'Energic Charge' },
        supportedNetworks: ['masterCard', 'visa', 'mada'],
        supportedCountries: ['SA'],
        version: 3,
        countryCode: 'SA',
      },
      /**
       * On ready callback
       * @returns
       */
      onReady: () => alert('Widget is ready'),
      /**
       * On error callback
       * @returns
       */
      onError: (error: any) => {
        alert(`⚠️ Widget error:${JSON.stringify(error)}`);
      },
      /**
       * On payment completed callback
       * @returns
       */
      onPaymentCompleted: (result: any) => {
        alert(`✅ Payment completed: ${JSON.stringify(result)}`);
      },
      /**
       * On payment failed callback
       * @returns
       */
      onPaymentFailed: (result: any) => {
        alert(`❌ Payment failed: ${JSON.stringify(result)}`);
      },
    };
    // ✅ Now safely append the widget script
    const script = document.createElement('script');
    script.src = `${domain && brandData?.hyperPayScriptUrl ? brandData?.hyperPayScriptUrl : config.hyperPayScriptUrl}?checkoutId=${checkoutId}`;
    script.async = true;
    document.body.appendChild(script);
  };
  /**
   * submitCheckoutId
   * @returns
   */
  const submitCheckoutAppleId = () => {
    alert(JSON.stringify({ checkoutAppleId }));
    // ✅ Define global config before loading the script
    (window as any).wpwlOptions = {
      style: 'plain',
      paymentTarget: '_top',
      applePay: {
        // displayName: 'Energic App',
        // totalLabel: 'Energic Charge',
        displayName: 'Energic App',
        total: { label: 'Energic Charge' },
        supportedNetworks: ['masterCard', 'visa', 'mada'],
        supportedCountries: ['SA'],
        version: 3,
        countryCode: 'SA',
      },
      /**
       * On ready callback
       * @returns
       */
      onReady: () => alert('Widget is ready'),
      /**
       * On error callback
       * @returns
       */
      onError: (error: any) => {
        alert(`⚠️ Widget error:${JSON.stringify(error)}`);
      },
      /**
       * On payment completed callback
       * @returns
       */
      onPaymentCompleted: (result: any) => {
        alert(`✅ Payment completed: ${JSON.stringify(result)}`);
      },
      /**
       * On payment failed callback
       * @returns
       */
      onPaymentFailed: (result: any) => {
        alert(`❌ Payment failed: ${JSON.stringify(result)}`);
      },
    };
    // ✅ Now safely append the widget script
    const script = document.createElement('script');
    script.src = `${domain && brandData?.hyperPayScriptUrl ? brandData?.hyperPayScriptUrl : config.hyperPayScriptUrl}?checkoutId=${checkoutAppleId}`;
    script.async = true;
    document.body.appendChild(script);
  };

  /**
   * changeInput
   * @param name
   * @param value
   */
  const changeInput = (name: string, value: string | number) => {
    setCheckoutId(String(value));
  };

  /**
   * changeInput
   * @param name
   * @param value
   */
  const changeInputApple = (name: string, value: string | number) => {
    setCheckoutAppleId(String(value));
  };

  /**
   * Get the guest token api call
   */
  const getGuestToken = async () => {
    // const response1 = await hyperPay.generateCheckoutId();
    // setCheckoutId(response1?.data?.checkoutId);
    removeLocalStorageItem('apiResponse');
    if (!guestToken) {
      const response = await charger.generateTempToken();
      setGuestToken(response?.data?.guestToken);
      setLocalStorageItem('guestToken', response?.data?.guestToken);
    }

    if (search) {
      console.log(search);
      setLocalStorageItem('apiResponse', search);
      navigate('/apple-pay/demo');
      // charger
      //   .getReturnApiCall(`${guestToken}${search}&isGuestUser=true`)
      //   .then((response) => {
      //     console.log(response);
      //     alert(JSON.stringify(response.data));
      //     setLocalStorageItem('apiResponse', JSON.stringify(response.data));
      //     navigate('/apple-pay/demo');
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //     alert(JSON.stringify(error?.response?.data));
      //     setLocalStorageItem('apiResponse', JSON.stringify(error?.response?.data));
      //     navigate('/apple-pay/demo');
      //   });
    }
  };
  useEffect(() => {
    getGuestToken();
  }, []);

  return (
    <div className="flex justify-center p-10 bg-gray-100 min-h-screen">
      <h2 className="text-xl font-semibold text-center mb-6">Add Your Card</h2>
      <div
        style={{
          display: 'flex',
          gap: '10px',
          alignItems: 'end',
          padding: '20px',
        }}>
        <CustomInput
          inputLabel="Checkout ID"
          value={checkoutId}
          type="text"
          placeholder="Checkout Id"
          name="name"
          onChangeValue={changeInput}
          valueRequired
        />
        <MyButton label="Apply check id" buttonType="submit" onClickFunc={submitCheckoutId} />
      </div>
      <div
        style={{
          display: 'flex',
          gap: '10px',
          alignItems: 'end',
          padding: '20px',
        }}>
        <CustomInput
          inputLabel="Apple Checkout ID"
          value={checkoutAppleId}
          type="text"
          placeholder="Checkout Id"
          name="name"
          onChangeValue={changeInputApple}
          valueRequired
        />
        <MyButton label="Apply check id" buttonType="submit" onClickFunc={submitCheckoutAppleId} />
      </div>
      {checkoutId && (
        <form
          action={window.location.href}
          className="paymentWidgets"
          data-brands="VISA MASTER MADA AMEX"
        />
      )}
      {checkoutAppleId && (
        <form action={window.location.href} className="paymentWidgets" data-brands="APPLEPAY" />
      )}
      <div>{message}</div>
    </div>
  );
}

export default HyperPayApplePayComponent;
